'use client';
import UltimateDashboard from '../components/Isolated/UltimateDashboard';

export default function Home() {
  
  return (
    <><UltimateDashboard/></>
  );
}
// 'use client';

// import { useState, useEffect } from 'react';
// import toast from 'react-hot-toast';
// import CoinSelector from '../components/CoinSelector';
// import CoinList from '../components/CoinList';
// import FetchedCoinList from '../components/FetchedCoinList';
// import TopGainers from '../components/TopGainers';
// import { getCoins, deleteCoin, deleteAllCoins } from '../services/api';

// export default function Home() {
//   const [coins, setCoins] = useState([]);
//   const [fetching, setFetching] = useState(false);
//   const [listType, setListType] = useState('fetched');
//   const [refreshTrigger, setRefreshTrigger] = useState(0);

//   const triggerRefresh = () => setRefreshTrigger(prev => prev + 1);

//   const loadCoins = async () => {
//     try {
//       const data = await getCoins();
//       setCoins(data);
//     } catch (error) {
//       console.error('Error loading coins:', error);
//       toast.error('Không thể tải danh sách coin');
//     }
//   };

//   const handleFetchData = async (symbol, interval, days) => {
//     if (!symbol) return;
    
//     setFetching(true);
//     try {
//       const API_URL = process.env.NEXT_PUBLIC_API_URL;
//       const response = await fetch(`${API_URL}/fetch`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ symbol, interval, days })
//       });
      
//       const result = await response.json();
//       if (response.ok) {
//         toast.success(`Đã lấy ${result.dataPoints?.ohlcv || 0} records cho ${symbol} (${interval})`);
//         triggerRefresh();
//         await loadCoins();
//       } else {
//         toast.error(result.error || 'Lỗi khi fetch data');
//       }
//     } catch (error) {
//       console.error('Fetch error:', error);
//       toast.error(error.message || 'Lỗi khi fetch data');
//     }
//     setFetching(false);
//   };

//   const handleDeleteCoin = async (symbol) => {
//     try {
//       await deleteCoin(symbol);
//       toast.success(`Đã xóa ${symbol}`);
//       await loadCoins();
//       triggerRefresh();
//     } catch (error) {
//       console.error('Delete error:', error);
//       toast.error('Lỗi khi xóa coin');
//     }
//   };

//   const handleDeleteAll = async () => {
//     if (confirm('⚠️ Bạn có chắc muốn xóa TẤT CẢ coin và dữ liệu? Không thể khôi phục!')) {
//       try {
//         await deleteAllCoins();
//         toast.success('Đã xóa tất cả');
//         await loadCoins();
//         triggerRefresh();
//       } catch (error) {
//         console.error('Delete all error:', error);
//         toast.error('Lỗi khi xóa tất cả');
//       }
//     }
//   };

//   useEffect(() => {
//     loadCoins();
//   }, []);

//   return (
//     <div className="container">
//       <header style={{ 
//         marginBottom: 30, 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         flexWrap: 'wrap', 
//         gap: 16 
//       }}>
//         <div>
//           <h1>📊 Binance MM Bot</h1>
//           <p style={{ color: '#94a3b8' }}>Phân tích dòng tiền thông minh - Live OI, CVD, Volume, Long/Short</p>
//         </div>
//         <button onClick={handleDeleteAll} className="btn btn-danger" style={{ cursor: 'pointer' }}>
//           🗑️ Xóa Tất Cả
//         </button>
//       </header>

//       {/* Top Gainers Section */}
//       <TopGainers />

//       <div className="grid-2" style={{ marginTop: 20 }}>
//         <div>
//           <CoinSelector onFetch={handleFetchData} isFetching={fetching} />
          
//           <div style={{ display: 'flex', gap: 8, marginBottom: 16, marginTop: 16 }}>
//             <button 
//               onClick={() => setListType('fetched')}
//               className={`btn ${listType === 'fetched' ? 'btn-primary' : ''}`}
//               style={{ 
//                 background: listType === 'fetched' ? '#3b82f6' : '#334155', 
//                 flex: 1,
//                 cursor: 'pointer'
//               }}
//             >
//               📋 Coin đã fetch
//             </button>
//             <button 
//               onClick={() => setListType('watched')}
//               className={`btn ${listType === 'watched' ? 'btn-primary' : ''}`}
//               style={{ 
//                 background: listType === 'watched' ? '#3b82f6' : '#334155', 
//                 flex: 1,
//                 cursor: 'pointer'
//               }}
//             >
//               👁️ Coin đang watch ({coins.length}/3)
//             </button>
//           </div>
          
//           {listType === 'fetched' ? (
//             <FetchedCoinList onRefresh={refreshTrigger} />
//           ) : (
//             <CoinList coins={coins} onDelete={handleDeleteCoin} />
//           )}
//         </div>

//         <div className="card" style={{ textAlign: 'center', padding: 40 }}>
//           <div style={{ fontSize: 48, marginBottom: 16 }}>👈</div>
//           <h3>Chọn một coin bên trái</h3>
//           <p style={{ color: '#94a3b8', marginTop: 8 }}>
//             Click vào coin để xem phân tích chi tiết<br />
//             hoặc nhấn <strong style={{ color: '#8b5cf6' }}>Watch OI</strong> để xem live data.
//           </p>
//           <hr style={{ margin: '20px 0', borderColor: '#334155' }} />
//           <div style={{ fontSize: 14, color: '#94a3b8' }}>
//             📌 <strong>Hướng dẫn:</strong><br />
//             1️⃣ Fetch coin mới từ Binance<br />
//             2️⃣ Click vào coin để xem phân tích<br />
//             3️⃣ Dùng Watch để tự động cập nhật<br />
//             4️⃣ Xem CVD, Volume, OI, Long/Short, Funding Rate<br />
//             5️⃣ 🔥 <strong>Watch OI</strong> để theo dõi real-time
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
